import Constants from 'constants/index';

export const getCountryFromApiCountry = userCountryPreference => {
  return Constants.SUPPORTED_COUNTRIES[userCountryPreference];
};
